// TODO slimm this props down as we dont use most of it
export default {
  idKey: {
    type: [String],
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },

  keeps: {
    type: Number,
    default: 30,
  },
  estimateSize: {
    type: Number,
    default: 50,
  },
  itemSize: {
    type: Number,
    default: 20,
  },
  hasDynamicSize: {
    type: Boolean,
    default: false,
  },
  scrollBehavior: {
    type: String,
    default: 'smooth',
  },

  direction: {
    type: String,
    default: 'vertical', // the other value is horizontal
  },
  start: {
    type: Number,
    default: 0,
  },
  offset: {
    type: Number,
    default: 0,
  },
  topThreshold: {
    type: Number,
    default: 0,
  },
  bottomThreshold: {
    type: Number,
    default: 0,
  },
}
